import React, { PureComponent } from 'react';
import {
  CloseCircleOutlined,
  DownOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
  Card,
  Col,
  Row,
  Divider,
  Modal,
  Input,
  Tooltip,
  Popover,
  List,
  Checkbox,
  Tag,
  Spin,
} from 'antd';
import moment from 'moment';
import { connect } from 'dva';
import InfiniteScroll from 'react-infinite-scroller';
import {
  makeSuppressObj,
  checkSuppression,
  getCurentRiskSuppression,
} from '../../../utils/suppressionHelper';
import getCloudAccountName from '../../../utils/getCloudAccountName';
import styles from './index.less';
import { userCan } from '@/utils/authority';

const FormItem = Form.Item;
const {confirm} = Modal;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

@Form.create()
@connect(({ signatureMetaData }) => ({
  metadata: signatureMetaData.metadata,
}))
class SingleSignatureUnsuppress extends PureComponent {
  state = {
    isVisible: false,
    selectedPath: '',
  };
  render() {
    const { type, record } = this.props;

    let rulesApplied = [];

    if (type === 'resource') {
      // render all suppression paths contains in this resource
      rulesApplied = record.risks[0].rulesApplied;
    }

    if (type === 'risk') {
      // render only suppression paths contains in this resource
      rulesApplied = record.rulesApplied;

      let recordParams = {
        cloudAccount: record.cloudAccountId ? record.cloudAccountId : '.*',
        resourceId: record.resourceId ? record.resourceId : '.*',
        signatureName: record.signatureName ? record.signatureName : '.*',
        regulationId: '.*',
        createdBy: '',
        reason: '',
      };
      let suppressObj = makeSuppressObj(recordParams);
      rulesApplied = getCurentRiskSuppression(rulesApplied, suppressObj.path);
    }

    return (
      <div
        style={{
          maxHeight: 600,
          width: 400,
          overflow: 'auto',
        }}
      >
        {this.RenderModal()}
        <div>{rulesApplied.map((rule, i) => this.RenderRule(rule, i))}</div>
      </div>
    );
  }

  RenderRule = (rule, i) => {
    let { dbSuppressed, cloudAccountList, metadata } = this.props;
    let currentSuppression = checkSuppression(dbSuppressed, rule);

    if (!currentSuppression) {
      return <Spin />;
    }

    let { path, createdBy, createdAt, reason } = currentSuppression;
    let { cloudAccountId, resourceId, regId, signatureId } = path;
    let cloudId = cloudAccountId.substr(1).slice(0, -1);
    let allAcc = getCloudAccountName(cloudAccountList, cloudId);
    let cloudAccName = allAcc.filter(acc => acc.id === cloudId);
    let accountName = cloudAccName.length > 0 ? cloudAccName[0].cloudAccountName : 'N/A';
    let currentSignature = metadata.find(v => v.name === signatureId.substr(1).slice(0, -1));

    return (
      <div key={i}>
        <Row>
          <Col span={9}>
            <div style={{ color: 'gray' }}> Cloud Account</div>
          </Col>
          <Col span={12}>{accountName}</Col>
          <Col offset={1}>
            {/* <Icon style={{ fontSize: '16px' }} type="edit" onClick={() => {}}></Icon> */}
            <EditOutlined onClick={() => this.openEditModal(currentSuppression)} />

            <CloseCircleOutlined
              style={{ marginLeft: '12px', fontSize: '16px' }}
              onClick={() => this.unSuppress(currentSuppression)}
            />
          </Col>
        </Row>

        <Row>
          <Col span={9}>
            <div style={{ color: 'gray' }}>Signature</div>{' '}
          </Col>
          <Col span={12}>
            <Tooltip title={currentSignature.description ? currentSignature.description : 'All'}>
              {signatureId === '/.*/' ? 'All' : signatureId.substr(1).slice(0, -1)}
            </Tooltip>
          </Col>
        </Row>
        <Row>
          <Col span={9}>
            <div style={{ color: 'gray' }}>Regulation</div>
          </Col>
          <Col span={12}>{regId === '/.*/' ? 'All' : regId.substr(1).slice(0, -1)}</Col>
        </Row>
        <Row>
          <Col span={9}>
            <div style={{ color: 'gray' }}> Resource</div>
          </Col>
          <Col span={12}>{resourceId.substr(1).slice(0, -1)}</Col>
        </Row>
        <Row style={{ marginTop: '5px' }}>
          <Col>
            <div style={{ color: 'gray', display: 'inline-block' }}> Suppressed on</div>{' '}
            {moment(new Date(createdAt.toDate())).format('MMM Do, YYYY hh:mm a')}{' '}
            <div style={{ color: 'gray', display: 'inline-block' }}> by </div> {createdBy}
          </Col>
        </Row>
        <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
      </div>
    );
  };

  openEditModal = path => {
    let { cloudAccountList } = this.props;

    let cloudAccounts = cloudAccountList.map(c => {
      if (path.path.cloudAccountId === `/${c.id}/`) {
        c.isChecked = true;
        return c;
      } else {
        c.isChecked = false;
        return c;
      }
    });

    this.setState({
      cloudAccounts,
      isVisible: true,
      selectedPath: path,
    });
    this.props.hidePopup();
  };

  unSuppress = dbPath => {
    let { dispatch } = this.props;
    // hide popup
    this.props.hidePopup();

    confirm({
      title: 'Are you sure you want to delete this suppression rule?',
      content: 'Doing so will un-suppress affected risks and regenerate security reports',
      okText: 'Unsuppress',
      okType: 'primary',

      cancelText: 'Cancel',
      onOk() {
        userCan('delete-suppress', () => {
          dispatch({
            type: 'suppression/deleteSuppress',
            payload: {
              suppressionData: [dbPath],
            },
          });
        })();
      },
      onCancel() {},
    });
  };

  onChangeCheckbox = (e, item) => {
    let cloudAccounts = [...this.state.cloudAccounts];

    var { dispatch } = this.props;
    const { checked } = e.target;

    if (checked) {
      let remainings = cloudAccounts.filter(v => v.id !== item.id);
      item.isChecked = true;
      let newArr = [...remainings, item];

      this.setState({
        cloudAccounts: newArr,
      });
    } else {
      let remainings = cloudAccounts.filter(v => v.id !== item.id);
      item.isChecked = false;
      let newArr = [...remainings, item];

      this.setState({
        cloudAccounts: newArr,
      });
    }

    var { dispatch } = this.props;

    if (checked) {
      let remainings = cloudAccounts.filter(v => v.id !== item.id);
      item.isChecked = true;
      let newArr = [...remainings, item];

      this.setState({
        cloudAccounts: newArr,
      });
    } else {
      let remainings = cloudAccounts.filter(v => v.id !== item.id);
      item.isChecked = false;
      let newArr = [...remainings, item];

      this.setState({
        cloudAccounts: newArr,
      });
    }
  };

  RenderModal = () => {
    const { getFieldDecorator } = this.props.form;
    let { unSuppress, cloudAccountList } = this.props;
    let { selectedPath, checkAll, cloudAccounts } = this.state;

    if (!cloudAccounts) {
      return null;
    }

    cloudAccounts = cloudAccounts.sort(function(a, b) {
      if (a.accountName < b.accountName) {
        return -1;
      }
      if (a.accountName > b.accountName) {
        return 1;
      }
      return 0;
    });

    if (!selectedPath) {
      return null;
    }

    let val = selectedPath;
    const cloudId = val && val.path.cloudAccountId.substr(1).slice(0, -1);
    const allAcc = getCloudAccountName(cloudAccountList, cloudId);
    const cloudAccName = allAcc.filter(acc => acc.id === cloudId);
    const ids = cloudAccountList.map(acc => acc.id);

    // return null;
    const content = (
      <div style={{ width: '310px', maxHeight: '225px' }} className={styles.demoinfinitecontainer}>
        <Row>
          <Col>
            <Checkbox
              checked={cloudAccounts.filter(v => v.isChecked).length === cloudAccounts.length}
              onChange={e => {
                this.setState({
                  cloudAccounts: [
                    ...this.state.cloudAccounts.map(account => {
                      account.isChecked = e.target.checked;
                      return account;
                    }),
                  ],
                });
                // this.setState({
                //   checkAll : e.target.checked
                // })
              }}
            >
              Select All
            </Checkbox>
            <Divider style={{ margin: '16px', width: '281px', marginLeft: '-6px' }} />
          </Col>
        </Row>

        {cloudAccounts.map(item => {
          return (
            <Row>
              <Col>
                <Checkbox
                  onChange={e => this.onChangeCheckbox(e, item)}
                  checked={item.isChecked}
                  key={item.id}
                  value={item.id}
                >
                  {item.accountName}
                  {item.provider === 'AWS' ? (
                    <img
                      src="/awslogo.png"
                      alt="aws"
                      height="18px"
                      style={{ marginBottom: '5px' }}
                    />
                  ) : item.provider === 'AZURE' ? (
                    <img
                      src="/azure@2x.png"
                      alt="azure"
                      height="12px"
                      style={{ marginBottom: '5px', marginLeft: '5px' }}
                    />
                  ) : null}
                </Checkbox>
                <Divider style={{ margin: '16px', width: '281px', marginLeft: '-6px' }} />
              </Col>
            </Row>
          );
        })}
      </div>
    );
    return (
      <div style={{ display: 'inline-block' }}>
        <Form {...formItemLayout} hideRequiredMark>
          <Modal
            title="Edit risks suppression rule"
            okText="Save"
            onOk={this.updatePath}
            onCancel={() => {
              this.setState({
                isVisible: false,
              });
            }}
            visible={this.state.isVisible}
          >
            {
              <div>
                <FormItem label="Cloud Account">
                  {getFieldDecorator('cloudAccount', {
                    initialValue: cloudAccName[0].cloudAccountName,
                    rules: [
                      {
                        required: true,
                        message: 'Please enter your CloudAccount name!',
                      },
                    ],
                  })(
                    <Popover
                      placement="bottomLeft"
                      onVisibleChange={this.handlePopOver}
                      content={content}
                      trigger="click"
                    >
                      <div
                        style={{
                          border: '1px solid #D9D9D9',
                          marginLeft: '2px',
                          marginRight: '10px',
                          height: '40px',
                          float: 'left',
                          width: '330px',
                          borderRadius: '4px',
                        }}
                      >
                        {cloudAccounts.length === 0 ? (
                          <div style={{ marginRight: '30px', marginTop: '9px', marginLeft: '9px' }}>
                            Select Accounts
                          </div>
                        ) : (
                          cloudAccounts.map((v, i) => {
                            if (v.isChecked) {
                              return (
                                <Tag
                                  key={i}
                                  style={{
                                    marginRight: '2px',
                                    marginTop: '9px',
                                    marginLeft: '5px',
                                  }}
                                >
                                  {v.accountName}
                                </Tag>
                              );
                            }
                          })
                        )}
                        <DownOutlined
                          style={{
                            marginTop: '10px',
                            float: 'right',
                            marginRight: '6px',
                            marginLeft: '5px',
                          }}
                        />
                      </div>
                    </Popover>
                  )}
                </FormItem>
                <FormItem label="Resources">
                  {getFieldDecorator('resources', {
                    initialValue: val.path.resourceId,
                    rules: [
                      {
                        required: true,
                        message: 'Please enter resourceId',
                      },
                    ],
                  })(
                    <Input
                      style={{ width: '330px' }}
                      suffix={
                        <Tooltip title="e.g: //[^\resource\n]*[\r\n]">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                  )}
                </FormItem>
                <FormItem label="Signature">
                  {getFieldDecorator('signature', {
                    initialValue: val.path.signatureId,
                    rules: [
                      {
                        required: true,
                        message: 'Please enter Signature',
                      },
                    ],
                  })(
                    <Input
                      style={{ width: '330px' }}
                      suffix={
                        <Tooltip title="e.g: //[^\signature\n]*[\r\n]">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                  )}
                </FormItem>
                <FormItem label="Regulation">
                  {getFieldDecorator('regulation', {
                    initialValue: val.path.regId,
                    rules: [
                      {
                        required: true,
                        message: 'Please enter regulation name',
                      },
                    ],
                  })(
                    <Input
                      style={{ width: '330px' }}
                      suffix={
                        <Tooltip title="e.g: //[^\regulation\n]*[\r\n]">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                  )}
                </FormItem>
                <FormItem label="Reason">
                  {getFieldDecorator('reason', {
                    initialValue: selectedPath.reason,
                    rules: [
                      {
                        required: true,
                        message: 'Please enter reason',
                      },
                    ],
                  })(
                    <Input
                      style={{ width: '330px' }}
                      suffix={
                        <Tooltip title="Reason for suppression">
                          <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                      }
                    />
                  )}
                </FormItem>
              </div>
            }
          </Modal>
        </Form>
      </div>
    );
  };

  updatePath = () => {
    const { dispatch } = this.props;

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let { resources, signature, regulation, reason } = values;

        const { selectedPath } = this.state;

        let suppressionData = [selectedPath];
        userCan('delete-suppress', () => {
          dispatch({
            type: 'suppression/deleteSuppress',
            payload: {
              type: 'edit',
              suppressionData,
            },
          });
        })();

        let filterAcc = this.state.cloudAccounts.filter(acc => acc.isChecked === true);

        let data = filterAcc.map(v => {
          let newParams = {
            path: {
              cloudAccountId: `/${v.id}/`,
              resourceId: resources,
              signatureId: signature,
              regId: regulation,
            },
            createdAt: selectedPath.createdAt,
            updatedAt: new Date(),
            createdBy: selectedPath.createdBy,
            reason: reason,
          };

          return newParams;
        });

        if (data.length > 0) {
          userCan('create-suppress', () => {
            dispatch({
              type: 'suppression/createSuppress',
              payload: {
                suppressionData: data,
              },
            });
          })();
        }
      }
      this.setState({
        isVisible: false,
      });
    });
  };
}

export default SingleSignatureUnsuppress;
